// extracted by mini-css-extract-plugin
module.exports = {"disabledButton":"ReadSpeaker_disabledButton__MNMr0","stopBtn":"ReadSpeaker_stopBtn__2Obby"};